import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import {ConsumableType, ConsumableWithCount} from "@/store/consumable/types";
import Sprite = Phaser.GameObjects.Sprite;
import Text = Phaser.GameObjects.Text;
import {EffectType} from "@/store/artifact/types";
import {Tr} from "@/i18n/i18n";
import SkillUtils from "@/utils/skill-utils";

export default class ConsumableDetailsPanel extends Container {

    private toDestroy: (Text|Sprite)[] = [];

    constructor(scene: Scene, x:number, y: number, canvas: HTMLCanvasElement, cc: ConsumableWithCount, isMirrored?:boolean){
        super(scene);

        let info = SpriteUtils.addSprite(scene, x + 73 + (isMirrored? -75-72:0), y-76,
            Keys.UI_BACKPACK_INFO, undefined, isMirrored? -1.05 : 1.05, 1);

        let isCut = cc.name.length > 18;
        let title = !isCut ? cc.name : (cc.name.substr(0, 17) + '...');

        let infoTitle = TextUtils.addTextByFamily(scene, title, x + 66 + (isMirrored? -75-66 + 9:0), y-109, '#d3b15a', 16,
            'normal', 420, Fonts.MYRIADPRO_REGULAR)
            .setOrigin(0.5, 0.5);

        let infoText = TextUtils.addTextByFamily(scene,  this.getInfoText(cc), x + 68 + (isMirrored? -75-66 + 9:0), y  -81,
            '#b3b3b3', 15, 'normal', 400, Fonts.MYRIADPRO_REGULAR);

        let infoValue = TextUtils.addTextByFamily(scene,  this.getEffectValue(cc), x + 68 + (isMirrored? -75-66 + 9:0), y -56,
            cc.consumableType == ConsumableType.PLAYER? '#65e775' : '#f14848', 15, 'normal', 400, Fonts.MYRIADPRO_REGULAR);

        this.add([info, infoTitle, infoText, infoValue]);
        this.toDestroy.push(info, infoTitle, infoText, infoValue);

        scene.input.on('pointerdown', () => {
            this.toDestroy.forEach(o => o.destroy());
            this.toDestroy = [];
        });
    }

    private getInfoText(cc: ConsumableWithCount){
        switch(cc.consumableType) {
            case ConsumableType.PLAYER:
                return this.getEffectTypeText(cc);
            case ConsumableType.ANY:
                return this.getEffectTypeText(cc);
            case ConsumableType.ENEMY:
                switch (cc.effectType) {
                    case EffectType.ATTACK:
                        return Tr("enemy.attack");
                    case EffectType.DEFENCE:
                        return Tr("enemy.defence");
                    case EffectType.ATTACK_DEFENCE:
                        return Tr("enemy.attack.defence");
                    case EffectType.HEALTH:
                        return Tr("enemy.health");
                    default:
                        return '';
                }
        }
    }

    private getEffectTypeText(cc: ConsumableWithCount) {
        switch (cc.effectType) {
            case EffectType.ATTACK:
                return Tr("player.attack");
            case EffectType.DEFENCE:
                return Tr("player.defence");
            case EffectType.ATTACK_DEFENCE:
                return Tr("player.attack.defence");
            case EffectType.HEALTH:
                return Tr("player.health");
            default:
                return '';
        }
    }

    private getEffectValue(cc: ConsumableWithCount){
        switch (cc.consumableType){
            case ConsumableType.PLAYER:
                return "+" + SkillUtils.formatMoreThanMillion(cc.effectValue);
            case ConsumableType.ENEMY:
                return  "-" + SkillUtils.formatMoreThanMillion(cc.effectValue);
            case ConsumableType.ANY:
                return "+" + SkillUtils.formatMoreThanMillion(cc.effectValue);

        }
    }
}
